import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Loader2, Clock } from "lucide-react";

interface FormActionsProps {
  loadingCategories: boolean;
  selectedRole?: string;
  onSkip?: () => void;
}

export const FormActions = ({ loadingCategories, selectedRole, onSkip }: FormActionsProps) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <Button type="submit" className="w-full">
        {loadingCategories ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            {t('onboarding.saving')}
          </>
        ) : selectedRole === 'talent' ? (
          t('onboarding.addPortfolio')
        ) : (
          t('onboarding.addOpportunity')
        )}
      </Button>

      {onSkip && (
        <Button
          type="button"
          variant="ghost"
          onClick={onSkip}
          className="w-full"
        >
          <Clock className="w-4 h-4 mr-2" />
          {t('onboarding.doItLater')}
        </Button>
      )}
    </div>
  );
};